export default "__VITE_ASSET__8TWqAHK3__"